<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("view") }} {{ $tc("customer", 1) }}</div>
      <div>
        <button
          class="btn-blue"
          @click.prevent.stop="onEditCustomer(customerDetails)"
          >{{ $t("edit") }}</button
        >
        <router-link class="btn-blue" to="customers"
          >{{ $tc("customer", 2) }} {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div
        class="col-md-12 py-1 h4 text-blue px-0 border-bottom font-weight-bold text-capitalize"
        >{{ customerDetails.cust_name }}</div
      >
      <div class="row border-bottom">
        <div class="col-6">
          <div class="d-flex align-items-center mb-3">
            <vue-material-icon
              name="mail_outline"
              :size="20"
            ></vue-material-icon>
            <span
              v-if="customerDetails.cust_email == null"
              class="ml-2 lh-1 mt-1"
              >-</span
            >
            <span v-else class="ml-2 lh-1 mt-1">{{
              customerDetails.cust_email
            }}</span>
          </div>

          <div class="d-flex align-items-center mb-3">
            <vue-material-icon
              name="phone"
              :size="20"
              title="asdasd"
            ></vue-material-icon>
            <div class="ml-2">{{ customerDetails.cust_mobile }}</div>
          </div>

          <div class="d-flex align-items-center mb-3">
            <vue-material-icon name="cake" :size="20"></vue-material-icon>
            <!-- <span class="ml-2 lh-1 mt-1">21 March 1996</span> -->
            <span
              v-if="
                customerDetails.cust_dob && customerDetails.cust_dob.length == 0
              "
              class="ml-2 lh-1 mt-1"
              >-</span
            >
            <span v-else class="ml-2 lh-1 mt-1">{{
              customerDetails.cust_dob | dateparse
            }}</span>
          </div>
        </div>
        <div class="col-6">
          <div class="d-flex align-items-center mb-3">
            <vue-material-icon
              name="perm_identity"
              :size="20"
            ></vue-material-icon>
            <!-- <span class="ml-2">Employee-2166</span> -->
            <span class="ml-2">{{ customerDetails.cust_code }}</span>
          </div>
          <div class="d-flex align-items-center mb-3">
            <vue-material-icon name="gps_fixed" :size="20"></vue-material-icon>
            <div class="ml-2"
              >{{ selected.City }} {{ " " }} {{ selected.State }} {{ " " }}
              {{ selected.Country }}</div
            >
            <!-- <div class="ml-2">Malad East, Mumbai Maharashtra</div> -->
          </div>
          <div class="d-flex align-items-center mb-3">
            <span class="text-success lh-1">
              <vue-material-icon
                v-if="customerDetails.cust_is_active == 'Y'"
                name="done"
                :size="20"
              ></vue-material-icon>
              <vue-material-icon
                v-else
                name="cancel"
                :size="20"
              ></vue-material-icon>
            </span>
            <div v-if="customerDetails.cust_is_active == 'Y'" class="ml-2"
              >{{ $tc("customer", 1) }} {{ $t("active") }}</div
            >
            <div v-else class="ml-2">User Inactive</div>
          </div>
        </div>
      </div>

      <div class="col-md-12 py-1 border-bottom">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc("doj") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="customerDetails.cust_doj" class="mr-3">{{
              customerDetails.cust_doj | dateparse
            }}</span>
            <span v-else-if="customerDetails.created_at" class="mr-3">{{
              customerDetails.created_at | dateparse
            }}</span>
            <span v-else>-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>

      <div class="col-md-12 py-1 border-bottom">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2"
            >{{ $tc("anniversary") }} {{ $tc("date") }}</div
          >
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span class="mr-3">{{
              customerDetails.cust_anniversary_date | dateparse
            }}</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1 border-bottom">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc("Gender") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span class="mr-3">{{
              customerDetails.gender == "M"
                ? "Male"
                : customerDetails.gender == "F"
                ? "Female"
                : customerDetails.gender == "O"
                ? "Others"
                : customerDetails.gender == "D"
                ? "Do Not Want To Disclose"
                : "-"
            }}</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1 border-bottom">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("institution") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span
              v-if="selected.Institution && selected.Institution.length > 0"
              class="mr-3"
              >{{ selected.Institution }}</span
            >
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1 border-bottom">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2"
            >{{ $t("booking") }} {{ $tc("user", 1) }}
            {{ $tc("category", 1) }}</div
          >
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span
              v-if="selected.User && selected.User.length > 0"
              class="mr-3"
              >{{ selected.User }}</span
            >
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1 border-bottom">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc("address") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="customerDetails.cust_address" class="mr-3">{{
              customerDetails.cust_address
            }}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>

      <div v-if="roleID == 1" class="col-md-12 py-1 border-bottom">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("createdat") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="customerDetails.created_at" class="mr-3">{{
              customerDetails.created_at | dateparse
            }}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div v-if="roleID == 1" class="col-md-12 py-1 border-bottom">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("createdby") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="customerDetails.created_by" class="mr-3">{{
              customerDetails.created_by
            }}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div v-if="roleID == 1" class="col-md-12 py-1 border-bottom">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("updatedat") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="customerDetails.updated_at" class="mr-3">{{
              customerDetails.updated_at | dateparse
            }}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div v-if="roleID == 1" class="col-md-12 py-1 border-bottom">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("updatedby") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="customerDetails.updated_by" class="mr-3">{{
              customerDetails.updated_by
            }}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MarketingService from "@/services/MarketingService";
  import MasterService from "@/services/MasterService";
  import moment from "moment";
  export default {
    data() {
      return {
        selected: {
          Institution: "",
          User: "",
          Country: "",
          State: "",
          City: "",
        },
        roleID: "",
        msgcinema: "",
        submitted: false,
        isRoleID: true,
        customerDetails: {
          cust_name: null,
          cust_code: null,
          cust_email: null,
          cust_mobile: null,
          cust_doj: "",
          cust_dob: "",
          cust_anniversary_date: null,
          institution_id: null,
          booking_user_category_id: null,
          cust_address: null,
          city_id: null,
          state_id: null,
          country_id: null,
          cust_verified: "N",
          cust_is_active: "N",
        },

        Institutions: [],
        InstitutionsMethod: {
          GET: "/admin/tablelist/",
          tableName: "ms_institutions",
          urlKey: "institutions",
        },
        Users: [],
        UserssMethod: {
          GET: "/admin/tablelist/",
          tableName: "ms_booking_user_categories",
          urlKey: "booking_user_categories",
        },
        Cities: [],
        CitiesMethod: {
          GET: "/admin/tablelist/",
          tableName: "ms_cities",
          urlKey: "cities",
        },
        States: [],
        StatesMethod: {
          GET: "/admin/tablelist/",
          tableName: "ms_states",
          urlKey: "states",
        },
        Countries: [],
        CountriesMethod: {
          GET: "/admin/",
          tableName: "ms_countries",
          urlKey: "countries",
        },
      };
    },
    beforeMount() {
      this.roleID = this.secureStore.get("USINFO").role_id;
      const { cust_id } = this.$route.query;

      // this.getCountriesList();

      if (cust_id) {
        this.getCustomerDetails(cust_id);
      } else {
        this.$router.go(-1);
      }

      // this.getCountriesList();
      // this.getInstitutionsList();
      // this.getUsersList();
      // this.getCustomerDetails();
    },
    mounted() {},
    methods: {
      getCustomerDetails: function(cust_id) {
        MarketingService.getSingleCustomerDetails({ cust_id }).then(
          (response) => {
            const { data } = response;
            // console.log("data :", data);
            if (data.Records) {
              this.customerDetails = {
                ...this.customerDetails,
                ...data.Records[0],
              };
              // console.log(" :", data.Records[0]);
              // this.customerDetails.cust_anniversary_date = moment(
              //   new Date(data.Records[0].cust_anniversary_date)
              // ).format("YYYY-MM-DD");
              // if(data.Records[0].cust_dob == null){this.customerDetails.cust_dob = data.Records[0].cust_dob;}else{
              // this.customerDetails.cust_dob = moment(
              //   new Date(data.Records[0].cust_dob)
              // ).format("YYYY-MM-DD");}
              // if (data.Records[0].cust_doj == null) {
              //   this.customerDetails.cust_doj = data.Records[0].cust_doj;
              // } else {
              //   this.customerDetails.cust_doj = moment(
              //     new Date(data.Records[0].cust_doj)
              //   ).format("YYYY-MM-DD");
              // }
              this.getInstitutionsList(data.Records[0].institution_id);
              this.getUsersList(data.Records[0].booking_user_category_id);
              this.getCountriesList(data.Records[0].country_id);
              this.getStatesList(
                data.Records[0].country_id,
                data.Records[0].state_id
              );
              this.getCitiesList(
                data.Records[0].state_id,
                data.Records[0].city_id
              );
            }
          }
        );
      },

      getCountriesList: function(country_id) {
        this.Countries = [];
        let payload = {
          tableName: "ms_countries",
          country_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Countries = data.Records;
              if (country_id) {
                this.Countries.map((x) => {
                  if (country_id === x.country_id) {
                    this.selected.Country = x.country_name;
                    this.onSelectHandler("country", x);
                  }
                  //  else {
                  //   // Show Errors
                  //   console.log("show error :", data.message);
                  // }
                });
              }
            }
          })
          .catch(this._CatchError);
      },
      getStatesList: function(cid, state_id) {
        let payload = {
          tableName: "ms_states",
          state_is_active: "Y",
          country_id: cid,
        };
        MasterService.GetActiveList(payload)
          // this.States = [];
          // let body = this.getRequestBody("GET", undefined, {
          //   ...this.StatesMethod,
          //   params: { id: "country_id-" + country_id }
          // });
          // MasterService.GlobalRequest(body)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.States = data.Records;
              if (state_id) {
                this.States.map((x) => {
                  if (state_id === x.state_id) {
                    this.selected.State = x.state_name;
                    this.onSelectHandler("state", x);
                    // this.getCitiesList(x.state_id, x.city_id);
                  }
                  // else {
                  //   // Show Errors
                  //   console.log("show error :", data.message);
                  // }
                });
              }
            }
          })
          .catch(this._CatchError);
      },
      getCitiesList: function(s_id, city_id) {
        this.Cities = [];
        let payload = {
          tableName: "ms_cities",
          city_is_active: "Y",
          state_id: s_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Cities = data.Records;
              if (city_id) {
                this.Cities.map((x) => {
                  if (city_id === x.city_id) {
                    this.selected.City = x.city_name;
                    this.onSelectHandler("city", x);
                  }
                  //  else {
                  //   // Show Errors
                  //   console.log("show error :", data.message);
                  // }
                });
              }
            }
          })
          .catch(this._CatchError);
      },
      getInstitutionsList: function(institution_id) {
        this.Institutions = [];
        let payload = {
          tableName: "ms_institutions",
          institution_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Institutions = data.Records;
              if (institution_id) {
                this.Institutions.map((x) => {
                  if (institution_id === x.institution_id) {
                    this.selected.Institution = x.institution_name;
                    this.onSelectHandler("institution", x);
                  }
                  // else {
                  //   // Show Errors
                  //   console.log("show error :", data.message);
                  // }
                });
              }
            }
          })
          .catch(this._CatchError);
      },
      getUsersList: function(booking_user_category_id) {
        this.Users = [];
        let payload = {
          tableName: "ms_booking_user_categories",
          buc_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Users = data.Records;
              if (booking_user_category_id) {
                this.Users.map((x) => {
                  if (booking_user_category_id === x.buc_id) {
                    this.selected.User = x.buc_category_name;
                    this.onSelectHandler("user", x);
                  }
                  // else {
                  //   // Show Errors
                  //   console.log("show error :", data.message);
                  // }
                });
              }
            }
          })
          .catch(this._CatchError);
      },
      onEditCustomer: function(customer) {
        this.$router.push({
          path: "/marketing/edit-Customers",
          query: { cust_id: customer.cust_id },
        });
      },
      onSelectHandler: function(type, value) {
        if (type == "country") {
          // console.log("value :", value);
          this.selected.country_id = value.country_id;
          this.selected.Country = value.country_name;
          this.customerDetails.country_id = value.country_id;
        } else if (type == "state") {
          (this.selected.State = value.state_name),
            (this.customerDetails.state_id = value.state_id);
          this.getCitiesList(value.state_id);
        } else if (type == "city") {
          (this.selected.City = value.city_name),
            (this.customerDetails.city_id = value.city_id);
        } else if (type == "institution") {
          (this.selected.Institution = value.institution_name),
            (this.customerDetails.institution_id = value.institution_id);
        } else if (type == "user") {
          (this.selected.User = value.buc_category_name),
            (this.customerDetails.booking_user_category_id = value.buc_id);
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CustomersComponents/viewCustomers.vue